import React from "react"
import { FormattedMessage } from "react-intl"
import "./DegreeLevelIndicator.css"
import { WingsText } from "@wingspans-ui"

const degreeLevelMessages = {
	certificate: {
		id: "certificate",
		defaultMessage: "Certificate",
	},
	associates: {
		id: "associates",
		defaultMessage: "Associates",
	},
	bachelors: {
		id: "bachelors",
		defaultMessage: "Bachelors",
	},
	graduate: {
		id: "graduate",
		defaultMessage: "Graduate",
	},
}

const DegreeLevelIndicator = ({ degreeLevel = "", isHighlighted = false }) => {
	const message = degreeLevelMessages[degreeLevel]

	if (!message) {
		return null
	}

	if (!isHighlighted) {
		return <span>—</span>
	}

	return (
		<div className={["degree-level-indicator", isHighlighted ? degreeLevel : "degree-level-indicator--faded" ].join(" ")}>
      <WingsText className={`degree-level-indicator-text ${isHighlighted ? "w-font-bold" : ""}`}>
        <FormattedMessage id={message.id} defaultMessage={message.defaultMessage} />
      </WingsText>
		</div>
	)
}

export default DegreeLevelIndicator
